import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background-50 flex flex-col items-center justify-center text-center px-4">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mt-6">
          Página não encontrada
        </h1>
        <p className="mt-2 text-sm text-foreground-500">{location.pathname}</p>
        <Link
          to="/"
          className="mt-6 inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-home-4-line"></i>
          </span>
          Voltar ao Início
        </Link>
      </div>
    </div>
  );
}